<template>
  <div>
    <status-module :appointment="appointment" class="mb-2"></status-module>
    <service-category-module
      :appointment="appointment"
      class="mb-2"
    ></service-category-module>
    <read-only-module>
      <template #header>
        <div>
          <b>These Fields are Only Editable in Pending Status</b>
        </div>
      </template>
      <template #body>
        <div>
          <detail-label
            label="Duration:"
            :value="
              durationLabel(
                appointment.duration_minutes,
                appointment.service_category
              )
            "
            class="mb-2"
          ></detail-label>
          <detail-label
            label="Technician:"
            :value="technicianLabel"
            class="mb-2"
          ></detail-label>
          <detail-label
            label="Scheduled:"
            :value="scheduledLabel"
          ></detail-label>
        </div>
      </template>
    </read-only-module>
  </div>
</template>

<script>
import DetailLabel from "@/components/DetailLabel.vue";
import ReadOnlyModule from "../modules/ReadOnlyModule.vue";
import ServiceCategoryModule from "../modules/ServiceCategory/ServiceCategoryModule.vue";
import StatusModule from "../modules/Status/StatusModule.vue";
export default {
  components: {
    ServiceCategoryModule,
    StatusModule,
    ReadOnlyModule,
    DetailLabel
  },
  props: {
    appointment: {
      type: Object,
      default: null
    }
  },
  computed: {
    scheduledLabel() {
      return this.scheduledDateTime(
        this.appointment.scheduled_time,
        this.appointment.arrival_window_start,
        this.appointment.arrival_window_end
      );
    },
    technicianLabel() {
      const { technician, assignment_pinned, pinned_reason } = this.appointment;
      return this.assignedTechnicianLabel(
        technician,
        assignment_pinned,
        pinned_reason
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
